(function() {
  "use strict";

  angular.module("OnDeviceConfigProperties")


    .controller("OnDeviceConfigPropertiesController", [
      '$scope', '$routeParams', 'currentTenant', 'EventHandlerService',
      '$http', 'URL_PARAMS', 'GoProfileModel', '$rootScope', 'PrinterListPOSTPaging',
      '$timeout', '$location', 'OnDeviceConfigService', 'EventServiceEvents',
      '$filter',
      function(
        $scope, $routeParams, currentTenant, EventHandlerService,
        $http, URL_PARAMS, GoProfileModel, $rootScope, PrinterListPOSTPaging,
        $timeout, $location, OnDeviceConfigService, EventServiceEvents,
        $filter
        ) {

        $scope.tenant = currentTenant;
        $scope.me = null;
        $scope.eventHandlerService = EventHandlerService;
        $scope.refresh = 0;
        $scope.goProfile = null;
        $scope.updatingPrinters = false;


        $scope.pageMetaData = new PrinterListPOSTPaging();
        $scope.helpCaption = 'HelpGoConfigurationPage';
        $scope.foreignScope = null;

        $scope.onDeviceConfig = null;

        $scope.editMode = false;

        (function(){
          $scope.enableOnDevice = $scope.tenant.info.enableOnDevice;
          initEventHandler();
          getOnDeviceConfig();
          setListeners();
        })();

        function initEventHandler() {
          $scope.eventHandlerService.deRegisterListeners();
        };

        function getOnDeviceConfig () {
          var onDeviceConfigID = $routeParams[URL_PARAMS.GO_PROFILE_ID.ROUTE];
          var url = $scope.tenant.info._links['px:onDeviceConfigs'].href + '/' + onDeviceConfigID;
          OnDeviceConfigService.getOnDeviceConfigByUrl(url).then(function(onDeviceConfig) {
            $scope.onDeviceConfig = onDeviceConfig;
            getDisabledHTML()
            getPrintersFirstPage();
          }).catch(function(error) {
            $scope.onDeviceConfig = null;
          });
        }


        function getDisabledHTML() {
          var goDisableContent = $filter("translate")('PrintixGoEnableOnDeviceText').replace(/<\/br\s*[\/]?>/gi, '');
          $scope.goDisableContentFormated = $filter("translate")(goDisableContent);
        }

        $scope.$watch(function () {
          return $rootScope.currentUser
        }, function() {
          if ($rootScope.currentUser) {
            $scope.me = $rootScope.currentUser;
          }
        })

        function getPrintersFirstPage () {
          $scope.pageMetaData.pagingCriteria.pageSize = 1;
          $scope.onDeviceConfig.getPrinters($scope.pageMetaData).then(function(printerListObject) {
            $scope.totalPrinters = printerListObject.page.totalElements;
            $scope.printers = printerListObject.list;
          }).catch( function(error) {
          });

        }

        $scope.updatePrinters = function () {
          $scope.updatingPrinters = true;
          $scope.onDeviceConfig.updatePrintersDeviceConfig().then(function(response) {
            $scope.updatingPrinters = false;
          }).catch(function(error) {
            $scope.updatingPrinters = false;
          });
        }

        $scope.uninstallGoFromPrinters = function () {
          $scope.updatingPrinters = true;
          $scope.onDeviceConfig.uninstallPrintersDeviceConfig().then(function(response) {
            $scope.updatingPrinters = false;
          }).catch(function(error) {
            $scope.updatingPrinters = false;
          });


        }

        $scope.editGoProfile = function () {
          $scope.editMode = !$scope.editMode;
        }

        $scope.openGoProfileMenu = function(event, onDeviceConfig) {
          $scope.closeAllMenues();
          $timeout(function () {
            $scope.menuContent = {
              menuItems: [
                {
                  title: 'Modify', selected: false, type: 'createOnDeviceConfig', breaker: true, disabled: enableOnDeviceState() || $scope.me.isSystemObserver(),
                  action: 'UPDATE', name: onDeviceConfig.info.name
                },
                {
                  title: 'AssignToPrinters', selected: false, type: 'assignOnDeviceToPrinters', breaker: true, disabled: enableOnDeviceState() || $scope.me.isSystemObserver(),
                  name: onDeviceName(onDeviceConfig.info.name), bypassCloseOutside: true
                },
                {
                  title: 'DeleteGoConfiguration', selected: false, type: 'deleteSignInProfile', breaker: true,
                  disabled: ($scope.totalPrinters > 0 ? true : enableOnDeviceState()) || $scope.me.isSystemObserver()
                },
                {
                  title: 'GoConfigurations', selected: false, type: 'link', breaker: true, href: '/admin/#/settings?settingsSection=printixGo'
                },
              ],
              context: onDeviceConfig,
              icon: 'icon-access-card-2',
              sizeClass: 'size125',
              type: 'ALLROUND'
            }
            $scope.menuSpecs = {
              position: {left: event.clientX, top: event.clientY},
              type: 'ALLROUND'
            }
          }, 50)
        }

        $scope.openContextMenu = function (selectedContextMenuItem, contextPosition, menu) {
          $scope.closeAllMenues();
          // DISGUSTING HAGIS
          if (selectedContextMenuItem.name) {
            selectedContextMenuItem.title = selectedContextMenuItem.name;
          }

          $timeout(function  () {
            $scope.selectedContextMenuItem = selectedContextMenuItem;
            $scope.contextPosition = contextPosition;
            $scope.context = menu ? menu.context : null;
            $scope.auxiliaries = {
              tenant: $scope.tenant,
              onDeviceConfig: $scope.onDeviceConfig
            }
            $scope.resource = $scope.tenant;
          }, 50)
        }


        $scope.closeAllMenues = function () {
          $scope.foreignScope = null;
          $scope.selectedContextMenuItem  =  null;
          $scope.contextPosition = null;
          $scope.context = null;
          $scope.menuContent = null;
          $scope.menuSpecs = null;
        }

        function onDeviceName(name) {
          return $filter("stringular")($filter("translate")("AssignXToPrinters"), name);
        }

        function enableOnDeviceState () {
          if ($scope.tenant.info.enableOnDevice === 'SUSPENDED') {
            return true;
          }
          return false;
        }

        $scope.updateResources = function () {
          getOnDeviceConfig();
        }

        function setListeners () {
          $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.TENANT_ONDEVICE_CONFIG_UPDATED, function (name, data) {
            if (data.onDeviceConfig === $scope.onDeviceConfig.info._links.self.href) {
              OnDeviceConfigService.getOnDeviceConfigByUrl(data.onDeviceConfig).then(function(onDeviceConfig) {
                $scope.onDeviceConfig = onDeviceConfig;
              }).catch(function(error) {
              });
            }
          })

          $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.TENANT_ONDEVICE_CONFIG_DELETED, function (name, data) {
            if (data.onDeviceConfig === $scope.onDeviceConfig.info._links.self.href) {
              $location.path('/settings').search({'settingsSection': 'printixGo'})
            }
          })
        }


      }
    ]);
})();
